import React from 'react';

export const BarChartLoading = () => {
  return (
    <div style={{ width: '100%', height: '100%', position: 'relative', resize: 'both' }}>
      <svg height="271" viewBox="0 0 1024 271" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" width="19" height="19" rx="3" fill="#ECEFF3" />
        <rect x="0.5" y="43" width="19" height="19" rx="3" fill="#ECEFF3" />
        <rect x="0.5" y="86" width="19" height="19" rx="3" fill="#ECEFF3" />
        <rect x="0.5" y="129" width="19" height="19" rx="3" fill="#ECEFF3" />
        <rect x="0.5" y="172" width="19" height="19" rx="3" fill="#ECEFF3" />
        <rect x="0.5" y="215" width="19" height="19" rx="3" fill="#ECEFF3" />
        <rect x="52.5" y="52" width="30" height="182" rx="3" fill="#ECEFF3" />
        <rect x="162.5" y="114" width="30" height="120" rx="3" fill="#ECEFF3" />
        <rect x="272.5" y="82" width="30" height="152" rx="3" fill="#ECEFF3" />
        <rect x="382.5" y="141" width="30" height="93" rx="3" fill="#ECEFF3" />
        <rect x="492.5" y="91" width="30" height="143" rx="3" fill="#ECEFF3" />
        <rect x="602.5" y="32" width="30" height="202" rx="3" fill="#ECEFF3" />
        <rect x="712.5" y="143" width="30" height="91" rx="3" fill="#ECEFF3" />
        <rect x="822.5" y="171" width="30" height="63" rx="3" fill="#ECEFF3" />
        <rect x="932.5" y="91" width="30" height="143" rx="3" fill="#ECEFF3" />
        <rect x="1042.5" y="145" width="30" height="89" rx="3" fill="#ECEFF3" />
        <rect x="52" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="162" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="272" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="382" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="491" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="601" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="711" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="823" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="932" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="1041" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="1151" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="1261" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="1371" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="1481" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="1591" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="1701" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="1811" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="1921" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
        <rect x="2031" y="252" width="32" height="19" rx="3" fill="#ECEFF3" />
      </svg>
    </div>
  );
};
